import { render, staticRenderFns } from "./IcmsAntecipacao.vue?vue&type=template&id=51de3ac8&scoped=true&"
import script from "./IcmsAntecipacao.vue?vue&type=script&lang=js&"
export * from "./IcmsAntecipacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51de3ac8",
  null
  
)

export default component.exports